import { Link } from 'react-router-dom';
import './primitives.css';

function ListRow({ rank, chip, title, sub, meta, href, className = '', children }) {
  const inner = (
    <div className={`list-row ${className}`.trim()}>
      {rank != null && <span className="list-rank">{rank}</span>}
      {chip != null && <span className="list-chip-slot">{chip}</span>}
      <div className="list-body">
        <div className="list-title">{title}</div>
        {sub && <div className="list-sub">{sub}</div>}
        {children}
      </div>
      {meta != null && <span className="list-meta">{meta}</span>}
      {href && <span className="list-chev" aria-hidden>→</span>}
    </div>
  );
  return href ? <Link to={href} className="list-link">{inner}</Link> : inner;
}

export default ListRow;
